import {useRouter} from "next/router"
import React, {useEffect, useRef} from "react"

const OnePricingSection = () => {
	const scriptLoadedRef = useRef(false)
	const containerRef = useRef<HTMLDivElement>(null)
	const lastLocaleRef = useRef<string | undefined>()
	const router = useRouter()

	useEffect(() => {
		if (scriptLoadedRef.current) return

		const script = document.createElement("script")
		script.src = "/pricingTableBundle36.js"
		script.async = true

		script.onload = () => {
			scriptLoadedRef.current = true
			mountWidget(router.locale || "en")
		}

		document.body.appendChild(script)

		return () => {
			document.body.removeChild(script)
		}
	}, [])

	useEffect(() => {
		if (lastLocaleRef.current && router.locale !== lastLocaleRef.current) {
			window.location.reload()
		}

		lastLocaleRef.current = router.locale
	}, [router.locale])

	return (
		<>
			<div
				ref={containerRef}
				/* eslint-disable-next-line jsx-quotes */
				id={"first-one-prices"}
			/>
		</>
	)
}

export default OnePricingSection

function mountWidget(locale: string | undefined) {
	try {
		// @ts-expect-error — the global object without types
		const widget = window?.ComparePricingTableWidget
		if (!widget) return

		const element = document.getElementById("first-one-prices")
		if (!element) return

		const lang = locale || "en"

		widget.mount("first-one-prices", 2, lang)
	} catch (error) {
		console.error("Widget mount failed:", error)
	}
}
